let counter = 0;

export default function useId() {
  counter++
  return {
    uid: `v-${counter}`
  };
}
